var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tdesign:secured"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.5003 0.861572L43.0837 7.71574V23.4999C43.0837 31.5819 38.1212 37.2317 33.4957 40.7391C30.7037 42.8365 27.6404 44.546 24.3894 45.821C24.3328 45.8429 24.276 45.8644 24.219 45.8856L24.1701 45.9032L24.1564 45.9072L24.1505 45.9091C24.1485 45.9091 24.1466 45.9091 23.5003 44.0624L22.8521 45.9111L22.8443 45.9072L22.8306 45.9032L22.7816 45.8837C22.5201 45.787 22.2602 45.6858 22.0022 45.5801C18.9756 44.332 16.1197 42.7047 13.503 40.7372C8.88137 37.2337 3.91699 31.5839 3.91699 23.5019V7.71574L23.5003 0.861572ZM23.5003 44.0624L22.8521 45.9111L23.5003 46.1382L24.1485 45.9111L23.5003 44.0624ZM23.5003 41.9631L23.518 41.9552C26.228 40.8361 28.7857 39.3786 31.13 37.6175C35.3169 34.447 39.167 29.8116 39.167 23.4999V10.4966L23.5003 5.01324L7.83366 10.4966V23.4999C7.83366 29.8116 11.6837 34.4431 15.8707 37.6195C18.2202 39.3833 20.7838 40.8441 23.5003 41.9631ZM35.3913 16.3383L21.544 30.1857L13.2347 21.8784L16.0058 19.1074L21.542 24.6475L32.6203 13.5692L35.3894 16.3383H35.3913Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecured);
export default __webpack_public_path__ + "static/media/secured.d8ce7bd6d42c0a89f0d492f4ebbd0be0.svg";
export { ForwardRef as ReactComponent };